var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _polygon, _polygon2, _polygon3, _polygon4, _path10, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeguro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.08 119.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#a0b1b5;}.cls-2{fill:#f2f2f2;}.cls-3{fill:#49565f;}.cls-4{fill:#d0635a;}.cls-5{fill:#fc7369;}.cls-6{fill:#e8bc7e;}.cls-7{fill:#fed287;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "seguro") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1.54,71.2H18.38a0,0,0,0,1,0,0V92.8A8.42,8.42,0,0,1,10,101.23h0A8.42,8.42,0,0,1,1.54,92.8V71.2A0,0,0,0,1,1.54,71.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M86.54,2.37H22A3.61,3.61,0,0,0,18.38,6V92.8a8.42,8.42,0,0,1-8,8.41l0,0H81.81a8.34,8.34,0,0,0,8.34-8.34V6A3.61,3.61,0,0,0,86.54,2.37Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M41.61,18.28H27.72a1.48,1.48,0,1,1,0-3H41.61a1.48,1.48,0,1,1,0,3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.37,25.86H26.83a.59.59,0,0,1-.59-.59.6.6,0,0,1,.59-.59H65.37a.6.6,0,0,1,.59.59A.59.59,0,0,1,65.37,25.86Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.37,31.18H26.83a.6.6,0,0,1-.59-.59.59.59,0,0,1,.59-.59H65.37a.59.59,0,0,1,.59.59A.6.6,0,0,1,65.37,31.18Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M65.37,36.5H26.83a.6.6,0,0,1,0-1.19H65.37a.6.6,0,0,1,0,1.19Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M54.62,41.81H26.83a.59.59,0,1,1,0-1.18H54.62a.59.59,0,0,1,0,1.18Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M38.22,88.28H26.83a.59.59,0,1,1,0-1.18H38.22a.59.59,0,0,1,0,1.18Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.31,88.28H41.92a.59.59,0,0,1,0-1.18h4.39a.59.59,0,0,1,0,1.18Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "62.9 95.22 55.01 112.85 62.37 110.04 67.99 97.5 62.9 95.22"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "73.07 99.78 65.17 117.4 62.37 110.04 67.99 97.5 73.07 99.78"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "73.07 100.1 81.53 117.46 84.1 110.02 78.07 97.66 73.07 100.1"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "83.08 95.22 91.54 112.58 84.1 110.02 78.07 97.66 83.08 95.22"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86,89.46l-.75-1.32.47-1.45a1.19,1.19,0,0,0-.33-1.26l-1.15-1.05V82.83a1.21,1.21,0,0,0-.71-1.1l-1.39-.62-.46-1.45a1.21,1.21,0,0,0-1-.83l-1.54-.17-.92-1.26A1.18,1.18,0,0,0,77,76.93l-1.49.31-1.23-.9a1.2,1.2,0,0,0-1.3-.08L71.65,77l-1.48-.48a1.19,1.19,0,0,0-1.26.33l-1,1.13H66.37a1.18,1.18,0,0,0-1.1.71l-.64,1.41-1.48.48a1.2,1.2,0,0,0-.83,1l-.16,1.51L60.92,84a1.2,1.2,0,0,0-.47,1.22l.31,1.52L59.85,88a1.22,1.22,0,0,0-.08,1.31l.76,1.32-.48,1.44a1.19,1.19,0,0,0,.33,1.26l1.15,1v1.56a1.19,1.19,0,0,0,.7,1.09l1.39.63.47,1.44a1.17,1.17,0,0,0,1,.83l1.55.17.91,1.26a1.18,1.18,0,0,0,1.22.47l1.49-.3,1.22.89a1.22,1.22,0,0,0,1.31.08l1.35-.77,1.47.48a1.19,1.19,0,0,0,1.26-.33l1-1.12h1.52a1.21,1.21,0,0,0,1.1-.7l.64-1.42,1.48-.48a1.19,1.19,0,0,0,.82-1l.17-1.51,1.23-.89a1.21,1.21,0,0,0,.48-1.21L85,92l.92-1.25A1.18,1.18,0,0,0,86,89.46Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 72.89,
    cy: 89.38,
    r: 10.96
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeguro);
export default __webpack_public_path__ + "static/media/seguro.49976d39da2e513c124e6bacfa8aaaa5.svg";
export { ForwardRef as ReactComponent };